export const enum AvailabilitySettingsModalType {
  timezone = 'timezone',
  idealCaseload = 'idealCaseload',
  disconnectGoogleCalendar = 'disconnectGoogleCalendar',
  connectGoogleCalendar = 'connectGoogleCalendar',
}
